import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import _ from "lodash";
import LocaleStrings from "../../../languages";
import {
  classNames,
  FILES_URL,
  APP_API_KEY,
  timeAgo,
  SMALL_DATE_FORMAT,
} from "../../../components/Common/constant";
import {
  ProductTextLocalized,
  updateMRP,
} from "../../../components/Common/product-model";
import Loader from "../../../components/Common/loader";
import { Fragment } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import NoImg from "../../../assets/images/noimg.png";
import { isbidWatchingSliderOpen } from "../actions";
import toast, { Toaster } from "react-hot-toast";

function UserWatchlist(props) {
  const {
    session,
    isLoggedIn,
    localLanguage,
    productWatchingModal,
    productWatchers,
  } = props;

  const [loading, setLoading] = useState(false);

  const closeSlideOvers = () => {
    props.isbidWatchingSliderOpen(false);
  };

  const renderBids = (item) => {
    return (
      <div className="grid grid-cols-4">
        <div className="col-span-3 flex pb-6">
          <div className="pr-3">
            <img
              key={item.id}
              className="max-w-none h-10 w-10 rounded-full ring-2 ring-white"
              src={`${FILES_URL}/users/${item.userid}.jpg?api_key=${APP_API_KEY}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = NoImg;
              }}
            />
          </div>
          <div>
            <div className="text-uname text-base font-normal">
              {item.username}
            </div>
            <div className="text-cardfooter text-xs font-normal">
              {moment(item.createdon).format(SMALL_DATE_FORMAT)}
            </div>
          </div>
        </div>
        <div className="text-link text-base font-normal text-right"></div>
      </div>
    );
  };
  //console.log("productWatchers", productWatchers);
  return (
    <>
      <Transition.Root show={productWatchingModal} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed inset-0 overflow-hidden z-50"
          open={productWatchingModal}
          onClose={() => closeSlideOvers()}
        >
          <div className="absolute inset-0 overflow-hidden">
            <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

            <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <div className="w-screen max-w-md">
                  <div className="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
                    <div className="min-h-0 flex-1 flex flex-col pt-3 overflow-y-scroll">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="slider-modal-headtext">
                            <h2
                              id="slide-over-heading"
                              className="text-xl font-normal text-primary"
                            >
                              {LocaleStrings.watcher_list}
                            </h2>
                          </Dialog.Title>
                          <div className="ml-3 h-7 flex items-center">
                            <button
                              onClick={() => closeSlideOvers()}
                              className="bg-white text-primary hover:text-gray-500 focus:outline-none"
                            >
                              <span className="sr-only">Close panel</span>
                              <XIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                        <div className="relative flex-1 mt-3">
                          {productWatchers && productWatchers.data ? (
                            productWatchers.data.length > 0 ? (
                              productWatchers.data.map((item, index) => {
                                return renderBids(item);
                              })
                            ) : (
                              ""
                            )
                          ) : (
                            <Loader />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  session: state.session,
  localLanguage: state.localLanguage,
  deviceSize: state.deviceSize,
  productWatchingModal: state.productWatchingModal,
  productWatchers: state.productWatchers,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      isbidWatchingSliderOpen,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserWatchlist);
